import { ref } from 'vue'
import { storeToRefs } from 'pinia'

// stores
import { useAccessStore } from '@/stores/AccessStore'

/**
 * Shared state for location selector modal
 * This ensures all components use the same modal state
 */
const locationSelectorModalIsOpen = ref(false)

/**
 * Composable for managing location selector functionality
 * Holds the shared modal state and exposes the access selection
 * @returns Object containing modal state, access selection state, and methods
 */
export function useLocationSelector() {
  const accessStore = useAccessStore()

  // Use storeToRefs to make store state reactive in composable
  const { accessAllowed, accessSelected } = storeToRefs(accessStore)

  /**
   * Saves the current access selection to localStorage
   * Note: The store automatically persists on changes, but this method ensures immediate save
   */
  function saveAccessSelection(): void {
    accessStore.persistToLocalStorage()
  }

  /**
   * Opens the location selector modal
   */
  function openLocationSelectorModal(): void {
    locationSelectorModalIsOpen.value = true
  }

  /**
   * Closes the location selector modal
   */
  function closeLocationSelectorModal(): void {
    locationSelectorModalIsOpen.value = false

    // Refresh the page
    window.location.reload()
  }

  return {
    // Modal state
    locationSelectorModalIsOpen,
    openLocationSelectorModal,
    closeLocationSelectorModal,
    // Access selection state
    accessSelected,
    accessAllowed,
    // Methods
    saveAccessSelection
  }
}
